import { ProductExperienceApi } from '../../models/product/product.api';
import { CommerceApiHttpService, CommerceApiProductContext } from '../../common/types';
import { ExtendedSMSProduct, SMSPointOfService } from '../../models/shared/ocb';
import { createProductDetail } from '../../mappers/ocb/product.mapper';
import { ProductDetail } from '../../models/product';

export class BffOcbProductExperienceApi implements ProductExperienceApi {
  constructor(private http: CommerceApiHttpService, private i18n: CommerceApiProductContext['i18n']) {}

  public async getProduct(productCode: string): Promise<ProductDetail> {
    const product = await this.http
      .get(`${productCode}`, {
        params: {
          fields: 'FULL',
        },
      })
      .then((res: any) =>
        createProductDetail(res.data as ExtendedSMSProduct, {
          i18n: this.i18n,
        }),
      );

    product.vendor = { pointOfServices: product.pointOfServices as Required<SMSPointOfService>[] };

    return product;
  }
}
